"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBody = ModalBody;
exports.ModalControls = ModalControls;
exports.ModalClose = ModalClose;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ModalBody(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-modal-body', className)
  }, children);
}

function ModalControls(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-modal-controls', className)
  }, children);
}

function ModalClose(_ref3) {
  var onClose = _ref3.onClose;
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: onClose,
    className: "modal-close is-large",
    "aria-label": "close"
  });
}

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      loaded: false
    };

    _this.fixBodyScroll = function () {
      document.querySelector('html').style.overflow = 'hidden';
      document.querySelector('body').style.overflow = 'hidden';
    };

    _this.unfixBodyScroll = function () {
      document.querySelector('html').style.overflow = 'auto';
      document.querySelector('body').style.overflow = 'auto';
    };

    _this.closeOnEscape = function (e) {
      return e.key === 'Escape' && _this.props.onClose();
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.open && this.fixBodyScroll();
      window.addEventListener('keydown', this.closeOnEscape);
      this.timeout = setTimeout(function () {
        return _this2.setState({
          loaded: true
        });
      }, 1);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      newProps.open ? this.fixBodyScroll() : this.unfixBodyScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unfixBodyScroll();
      window.removeEventListener('keydown', this.closeOnEscape);
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          children = _this$props.children,
          onClose = _this$props.onClose,
          className = _this$props.className,
          noClose = _this$props.noClose,
          loaded = this.state.loaded;
      return open && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('modal', 'frikin-modal', 'is-active', className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-background",
        onClick: onClose
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('modal-content', {
          loaded: loaded
        })
      }, children), !noClose && /*#__PURE__*/_react.default.createElement(ModalClose, {
        onClose: onClose
      }));
    }
  }]);

  return Modal;
}(_react.default.Component);

exports.default = Modal;
Modal.propTypes = {
  open: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  children: _propTypes.default.any
};
Modal.defaultProps = {
  open: true,
  onClose: function onClose() {}
};
ModalBody.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.any
};